import { RequestType } from './_types';
import { pipe } from './tools/pipe';
import { fields } from './internal/fields';
import { path } from './internal/path';
import { type } from './internal/type';
export const markdown = (x) => 'type' in x
    ? pipe(path('/markdown'), type(RequestType.Markdown))(x)
    : pipe(fields(x), path('/markdown'), type(RequestType.Markdown));
